var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _InstrumentCompositeBoxAdapter_context, _InstrumentCompositeBoxAdapter_box, _InstrumentCompositeBoxAdapter_cells;
import { Pointers } from "@opendaw/studio-enums";
import { Option } from "@opendaw/lib-std";
import { Devices } from "../../DeviceAdapter";
import { DeviceManualUrls } from "../../DeviceManualUrls";
import { IndexedBoxAdapterCollection } from "../../IndexedBoxAdapterCollection";
import { TrackType } from "../../timeline/TrackType";
import { InstrumentCompositeCellBoxAdapter } from "./InstrumentComposite/InstrumentCompositeCellBoxAdapter";
export class InstrumentCompositeBoxAdapter {
    constructor(context, box) {
        this.type = "instrument";
        this.accepts = "midi";
        this.manualUrl = DeviceManualUrls.InstrumentComposite;
        _InstrumentCompositeBoxAdapter_context.set(this, void 0);
        _InstrumentCompositeBoxAdapter_box.set(this, void 0);
        _InstrumentCompositeBoxAdapter_cells.set(this, void 0);
        __classPrivateFieldSet(this, _InstrumentCompositeBoxAdapter_context, context, "f");
        __classPrivateFieldSet(this, _InstrumentCompositeBoxAdapter_box, box, "f");
        __classPrivateFieldSet(this, _InstrumentCompositeBoxAdapter_cells, IndexedBoxAdapterCollection.create(box.cells, box => context.boxAdapters.adapterFor(box, InstrumentCompositeCellBoxAdapter), Pointers.InstrumentCompositeCell), "f");
    }
    get box() { return __classPrivateFieldGet(this, _InstrumentCompositeBoxAdapter_box, "f"); }
    get uuid() { return __classPrivateFieldGet(this, _InstrumentCompositeBoxAdapter_box, "f").address.uuid; }
    get address() { return __classPrivateFieldGet(this, _InstrumentCompositeBoxAdapter_box, "f").address; }
    get labelField() { return __classPrivateFieldGet(this, _InstrumentCompositeBoxAdapter_box, "f").label; }
    get iconField() { return __classPrivateFieldGet(this, _InstrumentCompositeBoxAdapter_box, "f").icon; }
    get defaultTrackType() { return TrackType.Notes; }
    get enabledField() { return __classPrivateFieldGet(this, _InstrumentCompositeBoxAdapter_box, "f").enabled; }
    get minimizedField() { return __classPrivateFieldGet(this, _InstrumentCompositeBoxAdapter_box, "f").minimized; }
    get acceptsMidiEvents() { return true; }
    get cells() { return __classPrivateFieldGet(this, _InstrumentCompositeBoxAdapter_cells, "f"); }
    deviceHost() {
        return __classPrivateFieldGet(this, _InstrumentCompositeBoxAdapter_context, "f").boxAdapters
            .adapterFor(__classPrivateFieldGet(this, _InstrumentCompositeBoxAdapter_box, "f").host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    *labeledAudioOutputs() {
        yield { address: this.address, label: this.labelField.getValue(), children: () => Option.None };
        for (const cell of __classPrivateFieldGet(this, _InstrumentCompositeBoxAdapter_cells, "f").adapters()) {
            yield { address: cell.address, label: cell.label, children: () => Option.wrap(cell.labeledAudioOutputs()) };
        }
    }
    terminate() { __classPrivateFieldGet(this, _InstrumentCompositeBoxAdapter_cells, "f").terminate(); }
}
_InstrumentCompositeBoxAdapter_context = new WeakMap(), _InstrumentCompositeBoxAdapter_box = new WeakMap(), _InstrumentCompositeBoxAdapter_cells = new WeakMap();
